import { LMS_INIT_SUCCESS } from '../constants';

const initialTextsState = {};

const textsReducer = (state = initialTextsState, action) => {
  const { type, payload } = action;

  switch (type) {
    case LMS_INIT_SUCCESS:
      return {
        ...state,
        ...(payload?.texts || {}),
      };

    default:
      return state;
  }
};

export default textsReducer;
